import {
	createBuiltInColorMap,
	type BuiltInColorMap,
} from '@atlassian/color-picker/utils/color-map';

// Fixed hex values for the neutral swatches surfaced alongside the brand
// palette. Dark mode is out of scope for company-hub today, so the pickers
// store raw hex (no token indirection, no getComputedStyle reads) — keeps
// storage simple and SSR-deterministic.
export const HUB_BORDER_NEUTRAL_HEX = '#DCDFE4'; // matches `color.border`
export const HUB_BORDER_NEUTRAL_BOLD_HEX = '#758195'; // matches `color.border.bold`

/**
 * Neutral swatches every tenant keeps, entitled or not — Premium gates palette
 * *tints*, not neutrals. Without these a premium-locked tenant with a dark
 * brand colour has no legible text or heading option but a custom hex.
 *
 * These live here rather than on the theming context deliberately: they are
 * static data, and the config-panel field tests mock the context module, so
 * constants exported from there read as `undefined` at the call site.
 *
 * Order matters — the picker renders swatches in array order.
 */
export const HUB_LOCKED_NEUTRAL_HEXES: ReadonlyArray<string> = ['#FFFFFF', '#000000'];
export const HUB_LOCKED_BORDER_NEUTRAL_HEXES: ReadonlyArray<string> = [
	'#FFFFFF',
	HUB_BORDER_NEUTRAL_HEX,
	HUB_BORDER_NEUTRAL_BOLD_HEX,
	'#000000',
];

/**
 * Reduced swatch map for premium-locked tenants: the brand anchor + the current
 * value(s). De-duped (lowercased) so `knownColors` has no repeats.
 */
export const buildLockedColorMap = (...hexes: string[]): BuiltInColorMap => {
	const knownColors = Array.from(new Set(hexes.filter(Boolean).map((hex) => hex.toLowerCase())));
	return createBuiltInColorMap({ knownColors });
};
